<template>
	<div class="index" v-cloak>
		<div class="index_main row_space_between">
			<div class="index_block blue" @click="$router.push('/intro')">
				<div class="index_btn animated fadeInLeftBig">
					<img v-lazy="require(`@/assets/index_img_3.jpg`)">
				</div>
			</div>
			<div class="index_block yellow" @click="$router.push('/web')">
				<div class="index_btn animated fadeInDownBig">
					<img v-lazy="require(`@/assets/index_img_4.jpg`)">
				</div>
			</div>
			<div class="index_block green" @click="$router.push('/pic')">
				<div class="index_btn animated fadeInRightBig">
					<img v-lazy="require(`@/assets/index_img_5.jpg`)">
				</div>
			</div>
		</div>
		<div class="index_img_wrap animated fadeInUpBig">
			<div class="index_intro row_space_between">
				<div class="index_intro_txt">
					2012年因兴趣开始自学Photoshop<br/>
					后又自学了JS、Vue、uniapp、electron等Web前端技术<br/>
					工作中不断学习，开始使用figma、摹客、月维等UI相关工具<br/>
					此后不断探索，渐渐发现学习路上所有的动力便是兴趣，兴趣永远是最好的老师
				</div>
				<img :src="require(`@/assets/logo_1.png`)">
			</div>
			<div class="version">版本号{{ version }}</div>
			<img :src="require(`@/assets/index_img_1.png`)" class="index_img_1">
			<img :src="require(`@/assets/index_img_2.png`)" class="index_img_2">
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
	import db from "@/common/js/db";
	import packageJson from '../../../package.json'

	export default {
		name: 'index',
		data() {
			return {
				version: ''
			}
		},
		destroyed() {
		},
		mounted() {
			localStorage.setItem('FUNLoaded', true)
			this.version = packageJson.version
		},
		methods: {
		}
	}
</script>

<style scoped lang="less">
	@import "../../common/less/index.less";

	@_blue: #84BBDD;
	@_yellow: #FBCA7F;
	@_green: #73AEBB;

	@_height: calc(100vh - 2 * @border_width);

	.index{
		border: @border_width solid #fff;
		height: @_height;
		overflow: hidden;
		position: relative;
	}
	.index_img_wrap{
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		z-index: 1;
	}
	.index_img_1{
		width: 33%;
		position: absolute;
		bottom: 0;
		left: 0;
		z-index: 2;
    max-height: 25vh;
	}
	.index_img_2{
		width: 67%;
		position: absolute;
		bottom: 0;
		right: 0;
		z-index: 2;
	}
	.index_intro{
		position: relative;
		z-index: 3;
		justify-content: flex-end;
		// margin-bottom: 10px;

		img{
			width: 11%;
			margin-left: 10px;
      height: 110px;
		}
	}
	.index_intro_txt{
		text-align: right;
		line-height: 27px;
		opacity: 0.4;
	}
	.index_block{
		width: 1/3*100%;
		height: @_height;

    img{
      user-select: none;
      pointer-events: none;
    }

	}
	.index_btn{
		cursor: pointer;
		margin: 20% auto 0 auto;
		background: #fff;
		border-radius: 10%;
		width: 22vw;
		height: 22vw;
		overflow: hidden;
		box-shadow: 0 0 15px 15px rgba(0,0,0,0.03);

		&:hover{
			box-shadow: none;
			border-radius: 10%;

			img{
				transform: scale(1.1, 1.1);
			}
		}

		img{
			width: 100%;
			transition: all 0.3s;
		}
	}
	.blue{
		background: @_blue;
	}
	.yellow{
		background: @_yellow;
	}
	.green{
		background: @_green;
	}
	.version{
		position: absolute;
		bottom: 3px;
		left: 3px;
		z-index: 10;
		color: #fff;
		opacity: 0.7;
		font-size: 12px;
	}
	/* 手机端强制横屏 */
	@media screen and (orientation:portrait) {
		@border_width: 20px;
		.index{
			border: @border_width solid #fff;
			height: calc(100vw - 2 * @border_width);
			overflow: hidden;
			position: relative;
			margin-left: -2 * @border_width;

			// 强制横屏
			width: calc(100vh - 2 * @border_width);
			transform-origin: 0 0;
			transform: rotateZ(90deg) translateY(-110%);
		}
		.index_btn{
			width: 22vh;
			height: 22vh;
		}
		.index_intro{
			margin-bottom: 0;

			img{
				width: 9%;
				height: 14vw;
				margin-left: 10px;
			}
		}
		.index_intro_txt{
			font-size: 9px;
			line-height: 14px;
		}
	}
	// 适配手机端非全屏浏览器(页面高度更短)
	@media screen and (min-height: 600px) and (max-height: 680px) and (max-width: 768px) {
		.index_intro img{
			margin-left: 0;
		}
		.index_intro_txt{
			line-height: 12px;
		}
		.index_img_2{
			height: 25vw;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue